import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * Redirects old PO-style detail URLs to Order Request detail (same id).
 * Routes: purchaseorderdetails/:id, mediapurchaseorderdetails/:id, purchaseorder/:id, sellerpurchaseorder/:id
 */
export const RedirectToOrderRequest = () => {
  const { id } = useParams();
  return <Navigate to={id ? `/home/order-request/${id}` : '/home/order-requests'} replace />;
};
